import { Component, OnInit ,ViewChild} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../_models';
import { UserService } from '../_services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NotificationService } from 'src/app/_services/notification.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-new-customers',
  templateUrl: './new-customers.component.html',
  styleUrls: ['./new-customers.component.css'],
})
export class NewCustomersComponent implements OnInit {
  displayedColumns: string[] = [
    'no',
    'name',
    'company',
    'mobile',
    'email',
    'registereddate',
    'status',
    'tool',
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;


  total: number;
  dataSource;
  arr;
  title = 'materialApp'; 
  color = 'primary';
  mode = 'indeterminate';
  value = 75;
  diameter=60
  loading = true
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public userId: string;
  public userStatus: string;
  isAdminUser: boolean = false;
  constructor(
    public userService: UserService,
    private route: ActivatedRoute,
    private notifyService: NotificationService,
    private router: Router
  ) {
    this.currentUserSubject = new BehaviorSubject<User>(
      JSON.parse(localStorage.getItem('currentUser'))
    );
    this.currentUser = this.currentUserSubject.asObservable();
    this.userId = this.currentUserSubject.value.userId;
  }

  ngOnInit(): void {
    // this.total = 0;
    this.userStatus = 'Active';
    this.getCustomers();
    this.isAdminUser =
      this.currentUserSubject.value.roles == 'Admin' ? true : false;
    this.dataSource.paginator = this.paginator;    
    this.manageGridColumn();
  }

  manageGridColumn() {
    if (!this.isAdminUser) {
      this.displayedColumns.pop();
    }
  }

  getCustomers() {
    this.loading = true;
    this.userService.getAllCustomers(this.userStatus).subscribe(
      (res) => {
        // this.dataSource = <any>res;
        // this.total = this.dataSource.length;
        this.arr = res  
        this.dataSource = new MatTableDataSource(this.arr);  
        this.dataSource.paginator = this.paginator;    
        this.total =  this.arr.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  ActivateCustomer(userId: string) {
    var sureToactivate = confirm(
      'Are you sure to activate this customer subscription?'
    );

    if (sureToactivate) {
      if (userId) {
        this.userService.ActivateUsersub(userId).subscribe(
          (data) => {
            if (data) {
              // console.log('true');
              this.notifyService.showSuccess(
                ' Activated Successfully ',
                'CSP Portal'
              );
              this.getCustomers();
            }
          },
          (error) => {}
        );
      }
    }
  }

  DeActivateCustomersub(userId: string) {
    //this.router.navigate(['/customer-detail', userId]);
    var sureToactivate = confirm(
      'Are you sure to deactivate this customer subscription?'
    );

    if (sureToactivate) {
      if (userId) {
        this.userService.DeactivateUsersub(userId).subscribe(
          (data) => {
            if (data) {
              // console.log('true');
              this.notifyService.showSuccess(
                ' Deactivated Successfully ',
                'CSP Portal'
              );
              this.getCustomers();
            }
          },
          (error) => {}
        );
      }
    }
  }

  //   DeleteCustomer(userId : string) {

  //     var sureToDelete =  confirm("Are you sure to delete this customer?");

  //     if(sureToDelete){
  //       if(userId){
  //         this.userService.DeleteUser(userId)
  //         .subscribe(
  //             data => {
  //               if(data){
  //                 this.getCustomers();
  //                 this.notifyService.showSuccess("Deleted successfully", "CSP Portal");
  //             }
  //           },
  //           error => {

  //           });
  //       }
  //     }
  //   }

  OnStatusChange() {
    //  let status = this.userStatus;
    this.getCustomers();
  }
}
